var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cSingleChoice-container"},_vm._l((_vm.selectdata),function(item,index){return _c('li',{key:index,staticClass:"select-item",class:{
      'select-noactive': item.id != _vm.selectedId && _vm.selectedId,
      'select-active': item.id == _vm.selectedId && _vm.selectedId,
      'select-num': _vm.rankNum && _vm.rankNum == 2,
      'select-num1': _vm.rankNum && _vm.rankNum == 3
    },on:{"click":function($event){return _vm.handelSelect(item)}}},[_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615dfaba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select/cSingleChoiceCom.vue
// module id = null
// module chunks = 